import type { IconNames } from '@repo/foundations';

export const getCountDisplay = (count: number | undefined) => {
	if (!count) {
		return '0';
	}
	if (count === 10000) {
		// Limit
		return '10,000+';
	}
	return `${count > 1000 ? `${(count / 1000).toFixed(0)},${(count % 1000).toString().padStart(3, '0')}` : count}`;
};

export const getIconName = (icon: string): IconNames => {
	switch (icon) {
		case 'tag-off':
			return 'tagOff';
		case 'topology-star':
			return 'topologyStar';
		case 'world':
			return 'world';
		case 'user-share':
			return 'userShare';
		case 'user-question':
			return 'userQuestion';
		case 'lock-open':
			return 'lockOpen';
		case 'activity':
			return 'activity';
		case 'clock-hour-3':
			return 'clockHour3';
		default:
			return 'tag';
	}
};
